import { render, staticRenderFns } from "./SCORAD.vue?vue&type=template&id=bc53404e&scoped=true&lang=pug&"
import script from "./SCORAD.vue?vue&type=script&lang=js&"
export * from "./SCORAD.vue?vue&type=script&lang=js&"
import style0 from "./SCORAD.vue?vue&type=style&index=0&id=bc53404e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc53404e",
  null
  
)

export default component.exports